import {
  BadgeCheck,
  Bell,
  ChevronsUpDown,
  CreditCard,
  LogOut,
  Sparkles,
  User,
} from "lucide-react"
import { Link } from "react-router";
import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from "@/components/ui/avatar"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from "@/components/ui/sidebar"
import type { CurrentUserFull } from "@/types/index"

export function NavUser({
  user,
}: {
  user: CurrentUserFull
}) {
  const sidebar = useSidebar()

  // Function to get user initials for the avatar fallback
  const getUserInitials = (name: string | undefined) => {
    if (!name) return "";
    return name
      .split(' ')
      .map(part => part[0])
      .join('')
      .toUpperCase()
      .substring(0, 2);
  };

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <SidebarMenuButton
              size="lg"
              className="h-9 w-full gap-1 group-[[data-collapsible=icon]]/sidebar-wrapper:w-9"
            >
              {sidebar.state === "collapsed" ? (
                <User className="h-6 w-6 text-muted-foreground" />
              ) : (
                <>
                  <Avatar className="h-6 w-6">
                    {/* <AvatarImage alt={user.user.name} /> */}
                    <AvatarFallback>{getUserInitials(user.user.name)}</AvatarFallback>
                  </Avatar>
                  <div className="w-[calc(100%-12px-16px)] flex-1 text-left group-[[data-collapsible=icon]]/sidebar-wrapper:hidden">
                    <p className="truncate text-xs font-medium leading-tight text-muted-foreground">
                      {user.user.name || "Unknown User"}
                    </p>
                    <p className="truncate text-xs leading-tight">{user.user.email}</p>
                  </div>
                  <ChevronsUpDown
                    strokeWidth={1.5}
                    className="h-3 w-3 shrink-0 text-muted-foreground group-[[data-collapsible=icon]]/sidebar-wrapper:hidden"
                  />
                </>
              )}
            </SidebarMenuButton>
          </DropdownMenuTrigger>
          <DropdownMenuContent
            className="min-w-40"
            align="start"
            sideOffset={14}
            alignOffset={10}
          >
            <DropdownMenuLabel>
              <p className="truncate text-xs font-normal leading-tight text-muted-foreground">
                Signed in as
              </p>
              <p className="truncate text-xs font-medium leading-tight">
                {user.user.email}
              </p>
            </DropdownMenuLabel>
            {/* <DropdownMenuSeparator /> */}
            {/* <DropdownMenuGroup>
              <DropdownMenuItem>
                <Sparkles />
                Upgrade to Pro
              </DropdownMenuItem>
            </DropdownMenuGroup> */}
            {/* <DropdownMenuSeparator />
            <DropdownMenuGroup>
              <DropdownMenuItem>
                <BadgeCheck />
                Account
              </DropdownMenuItem>
              <DropdownMenuItem>
                <CreditCard />
                Billing
              </DropdownMenuItem>
              <DropdownMenuItem>
                <Bell />
                Notifications
              </DropdownMenuItem>
            </DropdownMenuGroup> */}
            {/* <DropdownMenuSeparator /> */}
            <DropdownMenuItem asChild>
              <Link to="/logout">
                <LogOut className="mr-2 h-4 w-4" />
                Log out
              </Link>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </SidebarMenuItem>
    </SidebarMenu>
  )
}
